import NSPDPanel from './components/NSPDPanel';
import NSPDUpdateModal from './components/NSPDUpdateModal';

export const id = 'nspd-integration';
export const name = 'НСПД';

/**
 * Возвращает инструменты модуля для интеграции в тулбар.
 * Добавляет кнопку в режим "Данные".
 */
export const getTools = (icons = {}) => ({
    data: [
        {
            label: 'Внешние данные',
            items: [
                { 
                    id: 'nspd-search', 
                    label: 'НСПД', 
                    icon: icons.Globe ? <icons.Globe size={18} /> : null, 
                    title: 'Поиск объектов в НСПД' 
                },
            ]
        }
    ]
});

export { NSPDPanel as Panel, NSPDUpdateModal as UpdateModal };

